import machine from '@state-machine/machine';
function getCurrentHref() {
    return globalThis.location.href;
}
function getCurrentPathname() {
    return globalThis.location.pathname;
}
export default class Router {
    routeObjects;
    constructor(routeObjects) {
        this.routeObjects = routeObjects;
        globalThis.addEventListener('popstate', () => this.initialLoad());
    }
    handleLink = (event) => {
        event.preventDefault();
        const { currentTarget } = event;
        if (currentTarget instanceof HTMLAnchorElement) {
            const currentHref = getCurrentHref();
            if (currentHref !== currentTarget.href) {
                this.navigate(currentTarget.href);
            }
        }
    };
    initialLoad() {
        const currentPathname = getCurrentPathname();
        this.load(currentPathname);
    }
    navigate(href) {
        const url = new URL(href, globalThis.location.origin);
        globalThis.history.pushState({}, '', url);
        this.load(url.pathname);
    }
    load(pathname) {
        const currentRouteObject = this.getCurrentRouteObj(pathname);
        if (currentRouteObject) {
            currentRouteObject.callback();
        }
        else {
            machine.makeTransition(machine.value, 'navigateError', { currentRoute: pathname });
        }
    }
    getCurrentRouteObj(pathname) {
        const currentRouteObject = this.routeObjects.find((route) => route.pathname === pathname);
        if (!currentRouteObject)
            return;
        return currentRouteObject;
    }
}
